<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <login-card header-color="green">
        <h4 slot="title" class="title">Reset hasła</h4>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>email</md-icon>
          <label>Email...</label>
          <md-input v-model="email" type="email" />
        </md-field>
        <router-link slot="inputs" :to="{ path: '/login' }"
          >Zaloguj się</router-link
        >
        <md-button
          @click="submit()"
          slot="footer"
          class="md-simple md-success md-lg"
        >
          Resetuj
        </md-button>
      </login-card>
    </div>
  </div>
</template>
<script>
import { LoginCard } from '@/components'
import crmService from '../services/crmService'
export default {
  components: {
    LoginCard,
  },
  data() {
    return {
      email: '',
    }
  },
  methods: {
    submit() {
      crmService
        .resetPassword(this.email)
        .then(() => {
          this.$router.push('/login')
          this.$message('Hasło zostało zresetowane, sprawdź email')
        })
        .catch(error => this.error(error.response.data))
    },
  },
}
</script>

<style></style>
